import React, { useState, useEffect } from "react";
import NewDynamic_PR_table from "../../../../components/NewDynamic_PR_Table";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants/index";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { toast } from "react-toastify";

const LeaveHistoryReport = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Leave History Report"));
    fetchFilterData();
    fetchTeamLeaveReport();

  }, []);

  const employeeDetails = JSON.parse(localStorage.getItem("user")) || {};

  const todayDate = moment().add(1, "months").format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(3, "months").format("YYYY-MM-DD");

  const [leaveHistory, setLeaveHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [respStatus, setRepStatus] = useState(0);

  const columns = {
    EmployeeName: { text: "Employee", visible: "true" },
    TXNDate: { text: "Applied Date", align: "center", visible: "true" },
    FromDate: { text: "From Date", align: "center", visible: "true" },
    ToDate: { text: "To Date", align: "center", visible: "true" },
    ApplicationStatus: { text: "Status", visible: "true" },
    ActionByName: { text: "Action By", visible: "true" },
    ActionDate: { text: "Action Date", align: "center", visible: "true" },
    ActionRemark: { text: "Remark", visible: "true" },
  };

  const [apiStatus, setApiStatus] = useState(undefined);

  const [filterFormData, setFilterData] = useState([
    { label: "Employee", value: employeeDetails?.DefaultContactID },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    { label: "Status", value: "" },
  ]);


  const handleFilterReset = () => {
    setFilterData([
      { label: "Employee", value: employeeDetails?.DefaultContactID },
      { label: "Status", value: "" },
      {
        label: "From Date",
        value: moment(lastMonthDate).format("DD-MMM-YYYY"),
      },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ]);
    // Call API with empty/default parameters
    fetchTeamLeaveReport();
  };


  const fetchFilterData = async () => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}filter-data`)
      if (response?.status === 200) {
        //  employee list
        const employeeList = response?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(employeeList);

        // month list
        const monthlist = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setMonthList(monthlist);
      }
    } catch (error) {
      console.error("Fetching FIlter Data", error);

    }
  }

  const fetchTeamLeaveReport = async () => {
    setApiStatus(undefined)
      const EMpID = filterFormData.find((o) => o.label === "Employee")
      ? filterFormData.find((o) => o.label === "Employee").value : null
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave-reports/2?P_EmployeeID=${EMpID}&P_FromDate=&P_ToDate=&P_ApplicationStatus=`
      );
      if (response.status === 200) {
        setApiStatus(response?.status);
        const LeaveData = response?.data?.header;

        setLeaveHistory(LeaveData);


        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const handleGetData = async () => {
    setApiStatus(undefined)

    const EMpID = filterFormData.find((o) => o.label === "Employee")
      ? filterFormData.find((o) => o.label === "Employee").value : null
    if (!EMpID) {
      return toast.error("Please The Emplooyee")
    }
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave-reports/2?P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }&P_ApplicationStatus=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }`
      );
      if (response.status === 200) {
        setApiStatus(response?.status);
        const LeaveData = response?.data?.header;

        setLeaveHistory(LeaveData);

        //  employee list
        const employeeList = response?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(employeeList);

        // month list
        const monthlist = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setMonthList(monthlist);
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: [...employeeList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Status", type: "Select", options: [...monthList] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={leaveHistory}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isSorting={true}
              responseStatus={respStatus}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              handleReset={handleFilterReset}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveHistoryReport;
